var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentationChart02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 13.3333V17.5M15.0003 17.5L11.7075 14.756C11.1002 14.2499 10.7965 13.9968 10.4575 13.9001C10.1587 13.8149 9.84196 13.8149 9.54311 13.9001C9.20414 13.9968 8.90048 14.2499 8.29317 14.756L5.00033 17.5M6.66699 9.16667V10M10.0003 7.5V10M13.3337 5.83333V10M18.3337 2.5H1.66699M2.50033 2.5H17.5003V9.33333C17.5003 10.7335 17.5003 11.4335 17.2278 11.9683C16.9882 12.4387 16.6057 12.8212 16.1353 13.0608C15.6005 13.3333 14.9005 13.3333 13.5003 13.3333H6.50033C5.10019 13.3333 4.40013 13.3333 3.86535 13.0608C3.39494 12.8212 3.01249 12.4387 2.77281 11.9683C2.50033 11.4335 2.50033 10.7335 2.50033 9.33333V2.5Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationChart02);
export default __webpack_public_path__ + "static/media/presentation-chart-02.839ab7b7513a27e569ab22bf1a46ef23.svg";
export { ForwardRef as ReactComponent };